import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationInsuranceOldtimerWA: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_1864_6842"
        style={{ maskType: 'alpha' }}
        width="356"
        height="228"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v228H0V0z"></path>
      </mask>
      <g mask="url(#mask0_1864_6842)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M295.108 116.376a5.13 5.13 0 00-5.124 5.128v17.936h10.252v-17.936a5.127 5.127 0 00-5.128-5.128z"
        ></path>
        <circle
          r="33.5"
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 299.692 190.5)"
        ></circle>
        <circle
          r="21.5"
          fill="#fff"
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 299.692 190.5)"
        ></circle>
        <circle
          r="33.5"
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 59.692 190.5)"
        ></circle>
        <circle
          r="21.5"
          fill="#fff"
          stroke={colors.primary[200]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 59.692 190.5)"
        ></circle>
        <path
          fill={colors.primary[50]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M223.361 183.004H119.393a25.357 25.357 0 01-21.972-13.38 43.446 43.446 0 00-70.605-7.836 5.128 5.128 0 01-7.094.278 5.125 5.125 0 01-.562-7.078 53.697 53.697 0 0170.027-9.051 53.708 53.708 0 0117.206 18.739 14.895 14.895 0 0013 8.092h103.968c11.66 0 20.444-7.248 30.608-15.64 11.488-9.484 24.508-20.236 43.704-20.236a65.408 65.408 0 0138.8 13.72 5.123 5.123 0 01-1.981 9.26 5.124 5.124 0 01-3.835-.82 55.636 55.636 0 00-32.968-11.908c-15.512 0-26.036 8.688-37.176 17.888-10.72 8.828-21.804 17.972-37.152 17.972z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M59.36 136.876a53.809 53.809 0 0147.053 27.784 14.895 14.895 0 0013 8.092h103.948c11.66 0 20.444-7.248 30.608-15.64 9.88-8.156 20.92-17.2 36-19.6v-16h-61.204a15.661 15.661 0 01-15.656-15.656V67.5c.065-1.544-2.777-7.755-7.688-7.496h-143.5a10.248 10.248 0 00-10.248 10.244v67.256a53.494 53.494 0 017.688-.628z"
        ></path>
        <path
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M105.485 121.504v15.512a13.275 13.275 0 003.284 8.736l10.688 12.22a13.265 13.265 0 0010 4.532h24.716v-41h-48.688z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M105.484 70.252H72.192a7.712 7.712 0 00-7.712 7.712v28.156a15.384 15.384 0 0015.384 15.384h25.6l.02-51.252zM105.485 70.252h48.688V121.5h-48.688V70.252z"
        ></path>
        <path
          fill={colors.primary[100]}
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M202.86 121.504V77.96a7.71 7.71 0 00-7.708-7.708h-40.98v51.252h48.688z"
        ></path>
        <path
          stroke={colors.primary[200]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M154.172 121.504v41h40.996a7.683 7.683 0 005.444-2.257 7.702 7.702 0 002.248-5.447v-33.296h-48.688zM136.237 131.752h7.684M164.42 131.752h7.688"
        ></path>
        <g filter="url(#filter0_dd_1864_6842)">
          <circle cx="233" cy="85" r="55" fill="#fff"></circle>
          <circle
            cx="233"
            cy="85"
            r="53"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <path
          fill={colors.primary[200]}
          d="M228.096 91.488l-7.584-23.52h-6.864l-7.536 23.424-6.24-23.424h-7.008L202.32 102h6.912l7.776-24.24 7.776 24.24h6.816l9.408-34.032h-6.768l-6.144 23.52zM266.412 102h7.2l-12.96-34.032h-7.68L239.916 102h7.008l2.832-7.776h13.824l2.832 7.776zm-9.744-26.688l4.704 12.864h-9.408l4.704-12.864z"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M228.096 91.488l-1.428.46a1.5 1.5 0 002.879-.08l-1.451-.38zm-7.584-23.52l1.428-.46a1.5 1.5 0 00-1.428-1.04v1.5zm-6.864 0v-1.5c-.651 0-1.228.42-1.428 1.04l1.428.46zm-7.536 23.424l-1.449.386a1.499 1.499 0 002.877.073l-1.428-.459zm-6.24-23.424l1.449-.386a1.5 1.5 0 00-1.449-1.114v1.5zm-7.008 0v-1.5a1.498 1.498 0 00-1.445 1.902l1.445-.402zM202.32 102l-1.445.402c.18.649.771 1.098 1.445 1.098V102zm6.912 0v1.5a1.5 1.5 0 001.428-1.042l-1.428-.458zm7.776-24.24l1.428-.458a1.5 1.5 0 00-2.856 0l1.428.458zm7.776 24.24l-1.428.458a1.5 1.5 0 001.428 1.042V102zm6.816 0v1.5a1.5 1.5 0 001.446-1.1l-1.446-.4zm9.408-34.032l1.446.4a1.501 1.501 0 00-1.446-1.9v1.5zm-6.768 0v-1.5a1.5 1.5 0 00-1.451 1.12l1.451.38zm-4.716 23.06l-7.584-23.52-2.856.92 7.584 23.52 2.856-.92zm-9.012-24.56h-6.864v3h6.864v-3zm-8.292 1.04l-7.536 23.425 2.856.918 7.536-23.424-2.856-.918zm-4.659 23.498l-6.24-23.424-2.898.772 6.24 23.424 2.898-.772zm-7.689-24.538h-7.008v3h7.008v-3zm-8.453 1.902l9.456 34.032 2.89-.804-9.456-34.032-2.89.804zm10.901 35.13h6.912v-3h-6.912v3zm8.34-1.042l7.776-24.24-2.856-.916-7.776 24.24 2.856.916zm4.92-24.24l7.776 24.24 2.856-.916-7.776-24.24-2.856.916zm9.204 25.282h6.816v-3h-6.816v3zm8.262-1.1l9.408-34.032-2.892-.8-9.408 34.032 2.892.8zm7.962-35.932h-6.768v3h6.768v-3zm-8.219 1.12l-6.144 23.52 2.902.76 6.144-23.52-2.902-.76zM266.412 102l-1.409.513a1.5 1.5 0 001.409.987V102zm7.2 0v1.5a1.5 1.5 0 001.402-2.034l-1.402.534zm-12.96-34.032l1.402-.534a1.5 1.5 0 00-1.402-.966v1.5zm-7.68 0v-1.5c-.621 0-1.178.383-1.4.963l1.4.537zM239.916 102l-1.4-.537a1.5 1.5 0 001.4 2.037V102zm7.008 0v1.5a1.5 1.5 0 001.41-.987l-1.41-.513zm2.832-7.776v-1.5a1.5 1.5 0 00-1.409.987l1.409.513zm13.824 0l1.41-.513a1.5 1.5 0 00-1.41-.987v1.5zm-6.912-18.912l1.409-.515a1.5 1.5 0 00-2.817 0l1.408.515zm4.704 12.864v1.5a1.501 1.501 0 001.409-2.015l-1.409.515zm-9.408 0l-1.408-.515a1.5 1.5 0 001.408 2.015v-1.5zm14.448 15.324h7.2v-3h-7.2v3zm8.602-2.034l-12.96-34.032-2.803 1.068 12.96 34.032 2.803-1.068zm-14.362-34.998h-7.68v3h7.68v-3zm-9.08.963l-13.056 34.032 2.801 1.074 13.056-34.032-2.801-1.074zM239.916 103.5h7.008v-3h-7.008v3zm8.418-.987l2.832-7.776-2.819-1.026-2.832 7.776 2.819 1.026zm1.422-6.789h13.824v-3h-13.824v3zm12.415-.987l2.832 7.776 2.819-1.026-2.832-7.776-2.819 1.026zm-6.911-18.91l4.704 12.864 2.817-1.03-4.704-12.864-2.817 1.03zm6.112 10.849h-9.408v3h9.408v-3zm-7.999 2.015l4.704-12.864-2.817-1.03-4.704 12.864 2.817 1.03z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_1864_6842"
          width="142"
          height="142"
          x="162"
          y="22"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1864_6842"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1864_6842"
            result="effect2_dropShadow_1864_6842"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1864_6842"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationInsuranceOldtimerWA;
